module.exports = __webpack_public_path__ + "static/img/b5-1.577cd93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b5-1.png
// module id = ePTm
// module chunks = 1